export function inview_setting() {


  //一度のみのinview「.one」
  $(function() {
    $('.js-inview').one('inview', function(event, isInView) {
      $(this).addClass('show');
    });
  });

}